import React from 'react';
import './SpaceBackground.css';

const SpaceBackground: React.FC = () => {
  return (
    <>
      {/* Global Space Universe Background */}
      <div className="space-universe-bg" />
      <div className="space-stars-layer" />
      <div className="space-nebula-layer" />
    </>
  );
};

export default SpaceBackground;
